"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.disableOkButton = disableOkButton;
function disableOkButton() {
    const okButton = document.querySelector('.primary');
    if (okButton != null) {
        okButton.disabled = true;
    }
}
